<template>
    <component
        :is="tag"
        class="z-list"
        :class="[
            `z-list--${tag}`,
            `z-list--size-${size}`,
            { 'z-list--bordered': bordered },
            { 'z-list--reset-counter': resetCounter },
            { [`z-list--theme-${theme}`]: !icon && tag === 'ul' }
        ]"
        ref="wrapper"
    >
        <div v-if="isTimelineHorizontal" class="z-list__wrapper">
            <slot />
        </div>
        <slot v-else />
    </component>
</template>

<script setup>
import { ref, provide, computed, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
    size: {
        type: String,
        default: 'l',
        validator: prop => ['l', 'm'].includes(prop)
    },
    tag: {
        type: String,
        default: 'ul',
        validator: prop => ['ul', 'ol'].includes(prop)
    },
    bordered: {
        type: Boolean,
        default: false
    },
    resetCounter: {
        type: Boolean,
        default: false
    },
    icon: {
        type: String
    },
    theme: {
        type: String,
        default: 'square',
        validator: prop => ['dash', 'dot', 'square', 'timeline', 'timeline-horizontal'].includes(prop)
    }
})

provide('iconName', props.icon)
provide('tag', props.tag)
provide('size', props.size)
provide('theme', props.theme)

const wrapper = ref(null);
const isDragging = ref(false);
const startX = ref(0);
const scrollLeft = ref(0);

const isTimelineHorizontal = computed(() => props.theme === 'timeline-horizontal');

const onMouseDown = (event) => {
    isDragging.value = true;
    startX.value = event.pageX - wrapper.value.offsetLeft;
    scrollLeft.value = wrapper.value.scrollLeft;
};

const stopDragging = () => {
    isDragging.value = false;
};

const onMouseMove = (event) => {
    if (!isDragging.value) return;
    event.preventDefault();
    const x = event.pageX - wrapper.value.offsetLeft;
    const walk = (x - startX.value) * 2;
    wrapper.value.scrollLeft = scrollLeft.value - walk;
};

onMounted(() => {
    if(isTimelineHorizontal.value){
        wrapper.value.addEventListener('mousemove', onMouseMove);
        wrapper.value.addEventListener('mousedown', onMouseDown);
        wrapper.value.addEventListener('mouseup', stopDragging);
        wrapper.value.addEventListener('mouseleave', stopDragging);
    }
});

onBeforeUnmount(() => {
    if(isTimelineHorizontal.value){
        wrapper.value.removeEventListener('mousemove', onMouseMove);
        wrapper.value.removeEventListener('mousedown', onMouseDown);
        wrapper.value.removeEventListener('mouseup', stopDragging);
        wrapper.value.removeEventListener('mouseleave', stopDragging);
    }
});
</script>

<style lang="scss" src="./index.scss"></style>
